module.exports = __webpack_public_path__ + "img/empty-search.4399d842.svg";